<template>
    <div>
        <table class="ui two column table">
            <tbody>
                <tr v-for="(lineItem, index) in lineItems()" :key="index" v-if="lineItem.lineItemType !== 'total'">
                  <td class='line item description' v-if="lineItem.lineItemType === 'serviceCharge' && !showFeeInfo"><a v-on:click="showServiceFeeModal()">{{lineItem.lineItemDescription}}</a></td>
                  <td v-else>{{lineItem.lineItemDescription}}</td>
                  <td class='right aligned'>{{formatDollars(lineItem.lineItemCost)}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                <th>Total</th>
                <th class='right aligned'>{{formatDollars(total())}}</th>
                </tr>
            </tfoot>
        </table>
        <div v-if="showFeeInfo" class="ui blue segment inverted">
          <p>{{ serviceFeeInfo() }}</p>
        </div>
        <div v-else class="ui modal" id="serviceFeeInfoModal">
          <div class="header">
            <p>Service Fee Information</p>
          </div>
          <div class="content">
            <p>{{ serviceFeeInfo() }}</p>
          </div>
          <div class="actions">
            <div class="ui approve button">Thanks</div>
          </div>
        </div>
    </div>
</template>

<script>
  import { textUtil } from './mixins/textUtil.js'
  import LineItem from '../models/line_item.js'

  export default {
    name: 'CostTable',
    props: {
      fareLineItems: Array,
      showFeeInfo: Boolean
    },
    mixins: [textUtil],
    data: function () {
      return {
        someVar: ''
      }
    },
    methods: {
      lineItems: function () {
        return this.fareLineItems.filter((lineItem) => { return lineItem.lineItemType !== LineItem.Types.TOTAL })
      },
      total: function () {
        var itemsToSum = this.lineItems()
        return itemsToSum.reduce((acc, item) => { return acc + item.lineItemCost }, 0)
      },
      serviceFeeInfo: function () {
        return 'It is not necessary to tip your chauffeur. A 20% service charge is added to all reservations to fairly compensate all team members who contribute to your trip, including your chauffeur, reservationists, detailers, etc. If you would like to tip your chauffeur at the conclusion of service, this is at your discretion, but it is not expected.'
      },
      showServiceFeeModal: function () {
        $('#serviceFeeInfoModal')
          .modal('show')
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/CostTable.vue